import type { SkinId } from '@/features/game/components/board/skins/types';
import type { SkinComponentType } from '@/features/game/components/board/skins/metadata';
import {
  getSkinPawns,
  getSkinDice,
  getSkinBases,
  getSkinPlateaux
} from '@/features/game/components/board/skins/registry';

interface SkinPreviewProps {
  skinId: SkinId;
  componentType: SkinComponentType;
}

export function SkinPreview({ skinId, componentType }: SkinPreviewProps) {
  switch (componentType) {
    case 'pawn': {
      const Pawn = getSkinPawns(skinId).green;
      return (
        <div className="w-[60%] flex items-center justify-center">
          <Pawn className="w-full h-auto" />
        </div>
      );
    }
    case 'dice': {
      const Dice = getSkinDice(skinId).red;
      return (
        <div className="w-[55%] aspect-square flex items-center justify-center">
          <Dice value={6} />
        </div>
      );
    }
    case 'base': {
      const Base = getSkinBases(skinId).yellow;
      return (
        <div className="w-[85%] flex items-center justify-center">
          <Base viewBox="0 0 486 523" pawn1 pawn2 pawn3 pawn4 className="w-full h-auto" />
        </div>
      );
    }
    case 'plateaux': {
      const Plateaux = getSkinPlateaux(skinId).bottom;
      return (
        <div className="w-full h-full overflow-hidden flex items-end justify-center">
          <Plateaux viewBox="0 0 268 616" className="w-[70%] h-auto" />
        </div>
      );
    }
  }
}
